// Approximate ISO2 country centroids [lat, lng] for the analytics bubble map.
export const COUNTRY_CENTROIDS = {
  ES: [40.2, -3.7], PT: [39.4, -8.2], FR: [46.6, 2.4], DE: [51.1, 10.4], IT: [42.8, 12.8],
  GB: [54.0, -2.0], IE: [53.2, -8.0], NL: [52.2, 5.5], BE: [50.6, 4.6], LU: [49.8, 6.1],
  CH: [46.8, 8.2], AT: [47.6, 14.1], PL: [52.1, 19.4], CZ: [49.8, 15.5], SK: [48.7, 19.7],
  HU: [47.2, 19.4], RO: [45.9, 24.9], BG: [42.7, 25.5], GR: [39.1, 22.9], HR: [45.1, 15.5],
  SI: [46.1, 14.8], RS: [44.0, 21.0], BA: [44.0, 18.0], AL: [41.2, 20.1], MK: [41.6, 21.7],
  ME: [42.7, 19.4], DK: [56.0, 9.5], SE: [62.0, 15.0], NO: [64.0, 12.0], FI: [64.0, 26.0],
  EE: [58.6, 25.0], LV: [56.9, 24.6], LT: [55.2, 23.9], IS: [64.9, -19.0], UA: [48.4, 31.2],
  BY: [53.7, 27.9], MD: [47.2, 28.5], RU: [61.5, 100.0], TR: [39.0, 35.2], CY: [35.1, 33.4],
  MT: [35.9, 14.4], US: [39.8, -98.6], CA: [56.1, -106.3], MX: [23.6, -102.5], BR: [-14.2, -51.9],
  AR: [-38.4, -63.6], CL: [-35.7, -71.5], CO: [4.6, -74.3], PE: [-9.2, -75.0], VE: [6.4, -66.6],
  EC: [-1.8, -78.2], UY: [-32.5, -55.8], PY: [-23.4, -58.4], BO: [-16.3, -63.6], CR: [9.7, -83.8],
  PA: [8.5, -80.8], DO: [18.7, -70.2], GT: [15.8, -90.2], CU: [21.5, -77.8], MA: [31.8, -7.1],
  DZ: [28.0, 1.7], TN: [33.9, 9.6], EG: [26.8, 30.8], LY: [26.3, 17.2], ZA: [-30.6, 22.9],
  NG: [9.1, 8.7], KE: [-0.0, 37.9], GH: [7.9, -1.0], ET: [9.1, 40.5], TZ: [-6.4, 34.9],
  SN: [14.5, -14.5], CI: [7.5, -5.5], AO: [-11.2, 17.9], CM: [7.4, 12.4], SA: [23.9, 45.1],
  AE: [23.4, 53.8], QA: [25.4, 51.2], KW: [29.3, 47.5], IL: [31.0, 34.9], JO: [30.6, 36.2],
  LB: [33.9, 35.9], IQ: [33.2, 43.7], IR: [32.4, 53.7], PK: [30.4, 69.3], IN: [22.4, 78.9],
  BD: [23.7, 90.4], LK: [7.9, 80.8], NP: [28.4, 84.1], CN: [35.9, 104.2], JP: [36.2, 138.3],
  KR: [36.5, 127.9], TW: [23.7, 121.0], HK: [22.3, 114.2], TH: [15.9, 100.9], VN: [14.1, 108.3],
  MY: [4.2, 101.9], SG: [1.35, 103.8], ID: [-2.5, 118.0], PH: [12.9, 121.8], AU: [-25.3, 133.8],
  NZ: [-41.8, 174.9], KZ: [48.0, 66.9], GE: [42.3, 43.4], AZ: [40.1, 47.6], AM: [40.1, 45.0],
};
